import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OverlayPanel } from 'primeng/overlaypanel';
import { TripService } from 'src/app/services/trip/trip.service';
import { MessageService } from 'primeng/api';
import { ICountry } from 'src/app/interface/country.interface';

@Component({
    selector: 'app-install-overlay',
    templateUrl: './app-install-overlay.component.html',
    styleUrls: ['./app-install-overlay.component.scss'],
    providers: [MessageService]
})
export class AppInstallOverlayComponent {
    @ViewChild('op') op!: OverlayPanel;
    @Output() formSubmit = new EventEmitter<any>();
    isSending: boolean = false;


    installForm: FormGroup;
    countries: ICountry[] = [
        { label: 'United States (+1)', value: 'US', flag: 'assets/images/us.png', dial_code: '+1' },
        { label: 'India (+91)', value: 'US', flag: 'assets/images/india-flag-icon.svg', dial_code: '+91' },
    ];
    selectedCountry: any = {
        phone: null
    };

    constructor(
        private fb: FormBuilder,
        private tripService: TripService,
        private messageService: MessageService
    ) {
        this.installForm = this.fb.group({
            fullName: ['', Validators.required],
            phone: ['', Validators.required],
            email: ['', [Validators.email]]
        });
        this.selectedCountry.phone = this.countries[0];
    }

    onSubmit(op: OverlayPanel) {
        if (this.installForm.valid) {
            this.isSending = true;
            const formValue = {
                ...this.installForm.value,
                mobile: this.selectedCountry.phone.dial_code + this.installForm.value.phone
            };

            this.tripService.send_payment_link({
                mobile: formValue.mobile,
                email: formValue.email
            }).subscribe({
                next: (response) => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Payment link sent successfully'
                    });
                    this.formSubmit.emit(formValue);
                    op.hide();
                    this.installForm.reset();
                    this.selectedCountry.phone = this.selectedCountry.phone;
                    this.isSending = false;
                },
                error: (error) => {
                    console.error('Error sending payment link:', error);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send payment link'
                    });
                    this.isSending = false;
                }
            });
        }
    }

    onDismiss(op: OverlayPanel) {
        op.hide();
        this.installForm.reset();
        this.selectedCountry.phone = this.selectedCountry.phone;
    }

    onCountrySelect(country: ICountry, event: MouseEvent) {
        event.stopPropagation(); // This prevents the event from bubbling up
        this.selectedCountry.phone = country;
    }
}
